export enum notificationTypes {
    FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST',
    DELETE_NOTIFICATION = 'DELETE_NOTIFICATION',
    READ_NOTIFICATION = 'READ_NOTIFICATION',
    READ_ALL_NOTIFICATIONS = 'READ_ALL_NOTIFICATIONS',
    SET_NOTIFICATIONS = 'SET_NOTIFICATIONS',
}
